/**
 * Phone Number Validation Utilities
 * 
 * This file provides phone number validation based on country-specific length rules.
 * It uses a comprehensive database of phone number lengths for each country.
 */

// Comprehensive country phone number length data
// Format: dialCode -> { min, max, name, isoCode }
const COUNTRY_PHONE_DATA = {
  "1": { min: 10, max: 10, name: "USA/Canada", isoCode: "US" },
  "7": { min: 10, max: 10, name: "Russia", isoCode: "RU" },
  "20": { min: 10, max: 10, name: "Egypt", isoCode: "EG" },
  "27": { min: 9, max: 9, name: "South Africa", isoCode: "ZA" },
  "30": { min: 10, max: 10, name: "Greece", isoCode: "GR" },
  "31": { min: 9, max: 9, name: "Netherlands", isoCode: "NL" },
  "32": { min: 8, max: 9, name: "Belgium", isoCode: "BE" },
  "33": { min: 9, max: 9, name: "France", isoCode: "FR" },
  "34": { min: 9, max: 9, name: "Spain", isoCode: "ES" },
  "36": { min: 8, max: 9, name: "Hungary", isoCode: "HU" },
  "39": { min: 9, max: 11, name: "Italy", isoCode: "IT" },
  "40": { min: 9, max: 10, name: "Romania", isoCode: "RO" },
  "41": { min: 9, max: 9, name: "Switzerland", isoCode: "CH" },
  "43": { min: 10, max: 13, name: "Austria", isoCode: "AT" },
  "44": { min: 10, max: 10, name: "United Kingdom", isoCode: "GB" },
  "45": { min: 8, max: 8, name: "Denmark", isoCode: "DK" },
  "46": { min: 7, max: 13, name: "Sweden", isoCode: "SE" },
  "47": { min: 8, max: 8, name: "Norway", isoCode: "NO" },
  "48": { min: 9, max: 9, name: "Poland", isoCode: "PL" },
  "49": { min: 10, max: 11, name: "Germany", isoCode: "DE" },
  "51": { min: 9, max: 9, name: "Peru", isoCode: "PE" },
  "52": { min: 10, max: 10, name: "Mexico", isoCode: "MX" },
  "53": { min: 8, max: 8, name: "Cuba", isoCode: "CU" },
  "54": { min: 10, max: 10, name: "Argentina", isoCode: "AR" },
  "55": { min: 10, max: 11, name: "Brazil", isoCode: "BR" },
  "56": { min: 9, max: 9, name: "Chile", isoCode: "CL" },
  "57": { min: 10, max: 10, name: "Colombia", isoCode: "CO" },
  "58": { min: 10, max: 10, name: "Venezuela", isoCode: "VE" },
  "60": { min: 9, max: 10, name: "Malaysia", isoCode: "MY" },
  "61": { min: 9, max: 9, name: "Australia", isoCode: "AU" },
  "62": { min: 9, max: 12, name: "Indonesia", isoCode: "ID" },
  "63": { min: 10, max: 10, name: "Philippines", isoCode: "PH" },
  "64": { min: 8, max: 10, name: "New Zealand", isoCode: "NZ" },
  "65": { min: 8, max: 8, name: "Singapore", isoCode: "SG" },
  "66": { min: 9, max: 9, name: "Thailand", isoCode: "TH" },
  "81": { min: 10, max: 10, name: "Japan", isoCode: "JP" },
  "82": { min: 9, max: 10, name: "South Korea", isoCode: "KR" },
  "84": { min: 9, max: 10, name: "Vietnam", isoCode: "VN" },
  "86": { min: 11, max: 11, name: "China", isoCode: "CN" },
  "90": { min: 10, max: 10, name: "Turkey", isoCode: "TR" },
  "91": { min: 10, max: 10, name: "India", isoCode: "IN" },
  "92": { min: 10, max: 10, name: "Pakistan", isoCode: "PK" },
  "93": { min: 9, max: 9, name: "Afghanistan", isoCode: "AF" },
  "94": { min: 9, max: 9, name: "Sri Lanka", isoCode: "LK" },
  "95": { min: 8, max: 10, name: "Myanmar", isoCode: "MM" },
  "98": { min: 10, max: 10, name: "Iran", isoCode: "IR" },
  "212": { min: 9, max: 9, name: "Morocco", isoCode: "MA" },
  "213": { min: 9, max: 9, name: "Algeria", isoCode: "DZ" },
  "216": { min: 8, max: 8, name: "Tunisia", isoCode: "TN" },
  "218": { min: 9, max: 9, name: "Libya", isoCode: "LY" },
  "220": { min: 7, max: 7, name: "Gambia", isoCode: "GM" },
  "221": { min: 9, max: 9, name: "Senegal", isoCode: "SN" },
  "222": { min: 8, max: 8, name: "Mauritania", isoCode: "MR" },
  "223": { min: 8, max: 8, name: "Mali", isoCode: "ML" },
  "224": { min: 8, max: 9, name: "Guinea", isoCode: "GN" },
  "225": { min: 10, max: 10, name: "Ivory Coast", isoCode: "CI" },
  "226": { min: 8, max: 8, name: "Burkina Faso", isoCode: "BF" },
  "227": { min: 8, max: 8, name: "Niger", isoCode: "NE" },
  "228": { min: 8, max: 8, name: "Togo", isoCode: "TG" },
  "229": { min: 8, max: 8, name: "Benin", isoCode: "BJ" },
  "230": { min: 8, max: 8, name: "Mauritius", isoCode: "MU" },
  "231": { min: 7, max: 8, name: "Liberia", isoCode: "LR" },
  "232": { min: 8, max: 8, name: "Sierra Leone", isoCode: "SL" },
  "233": { min: 9, max: 9, name: "Ghana", isoCode: "GH" },
  "234": { min: 10, max: 10, name: "Nigeria", isoCode: "NG" },
  "235": { min: 8, max: 8, name: "Chad", isoCode: "TD" },
  "236": { min: 8, max: 8, name: "Central African Republic", isoCode: "CF" },
  "237": { min: 9, max: 9, name: "Cameroon", isoCode: "CM" },
  "238": { min: 7, max: 7, name: "Cape Verde", isoCode: "CV" },
  "239": { min: 7, max: 7, name: "Sao Tome", isoCode: "ST" },
  "240": { min: 9, max: 9, name: "Equatorial Guinea", isoCode: "GQ" },
  "241": { min: 7, max: 8, name: "Gabon", isoCode: "GA" },
  "242": { min: 9, max: 9, name: "Congo", isoCode: "CG" },
  "243": { min: 9, max: 9, name: "DR Congo", isoCode: "CD" },
  "244": { min: 9, max: 9, name: "Angola", isoCode: "AO" },
  "245": { min: 7, max: 7, name: "Guinea-Bissau", isoCode: "GW" },
  "246": { min: 7, max: 7, name: "Diego Garcia", isoCode: "IO" },
  "247": { min: 4, max: 4, name: "Ascension", isoCode: "AC" },
  "248": { min: 7, max: 7, name: "Seychelles", isoCode: "SC" },
  "249": { min: 9, max: 9, name: "Sudan", isoCode: "SD" },
  "250": { min: 9, max: 9, name: "Rwanda", isoCode: "RW" },
  "251": { min: 9, max: 9, name: "Ethiopia", isoCode: "ET" },
  "252": { min: 7, max: 8, name: "Somalia", isoCode: "SO" },
  "253": { min: 8, max: 8, name: "Djibouti", isoCode: "DJ" },
  "254": { min: 9, max: 9, name: "Kenya", isoCode: "KE" },
  "255": { min: 9, max: 9, name: "Tanzania", isoCode: "TZ" },
  "256": { min: 9, max: 9, name: "Uganda", isoCode: "UG" },
  "257": { min: 8, max: 8, name: "Burundi", isoCode: "BI" },
  "258": { min: 9, max: 9, name: "Mozambique", isoCode: "MZ" },
  "260": { min: 9, max: 9, name: "Zambia", isoCode: "ZM" },
  "261": { min: 9, max: 9, name: "Madagascar", isoCode: "MG" },
  "262": { min: 9, max: 9, name: "Reunion", isoCode: "RE" },
  "263": { min: 9, max: 9, name: "Zimbabwe", isoCode: "ZW" },
  "264": { min: 9, max: 9, name: "Namibia", isoCode: "NA" },
  "265": { min: 9, max: 9, name: "Malawi", isoCode: "MW" },
  "266": { min: 8, max: 8, name: "Lesotho", isoCode: "LS" },
  "267": { min: 7, max: 8, name: "Botswana", isoCode: "BW" },
  "268": { min: 8, max: 8, name: "Eswatini", isoCode: "SZ" },
  "269": { min: 7, max: 7, name: "Comoros", isoCode: "KM" },
  "290": { min: 4, max: 4, name: "Saint Helena", isoCode: "SH" },
  "291": { min: 7, max: 7, name: "Eritrea", isoCode: "ER" },
  "297": { min: 7, max: 7, name: "Aruba", isoCode: "AW" },
  "298": { min: 6, max: 6, name: "Faroe Islands", isoCode: "FO" },
  "299": { min: 6, max: 6, name: "Greenland", isoCode: "GL" },
  "350": { min: 8, max: 8, name: "Gibraltar", isoCode: "GI" },
  "351": { min: 9, max: 9, name: "Portugal", isoCode: "PT" },
  "352": { min: 8, max: 9, name: "Luxembourg", isoCode: "LU" },
  "353": { min: 9, max: 9, name: "Ireland", isoCode: "IE" },
  "354": { min: 7, max: 7, name: "Iceland", isoCode: "IS" },
  "355": { min: 9, max: 9, name: "Albania", isoCode: "AL" },
  "356": { min: 8, max: 8, name: "Malta", isoCode: "MT" },
  "357": { min: 8, max: 8, name: "Cyprus", isoCode: "CY" },
  "358": { min: 9, max: 10, name: "Finland", isoCode: "FI" },
  "359": { min: 8, max: 9, name: "Bulgaria", isoCode: "BG" },
  "370": { min: 8, max: 8, name: "Lithuania", isoCode: "LT" },
  "371": { min: 8, max: 8, name: "Latvia", isoCode: "LV" },
  "372": { min: 7, max: 8, name: "Estonia", isoCode: "EE" },
  "373": { min: 8, max: 8, name: "Moldova", isoCode: "MD" },
  "374": { min: 8, max: 8, name: "Armenia", isoCode: "AM" },
  "375": { min: 9, max: 9, name: "Belarus", isoCode: "BY" },
  "376": { min: 6, max: 9, name: "Andorra", isoCode: "AD" },
  "377": { min: 8, max: 9, name: "Monaco", isoCode: "MC" },
  "378": { min: 6, max: 10, name: "San Marino", isoCode: "SM" },
  "380": { min: 9, max: 9, name: "Ukraine", isoCode: "UA" },
  "381": { min: 8, max: 9, name: "Serbia", isoCode: "RS" },
  "382": { min: 8, max: 8, name: "Montenegro", isoCode: "ME" },
  "383": { min: 8, max: 9, name: "Kosovo", isoCode: "XK" },
  "385": { min: 8, max: 9, name: "Croatia", isoCode: "HR" },
  "386": { min: 8, max: 8, name: "Slovenia", isoCode: "SI" },
  "387": { min: 8, max: 8, name: "Bosnia", isoCode: "BA" },
  "389": { min: 8, max: 8, name: "North Macedonia", isoCode: "MK" },
  "420": { min: 9, max: 9, name: "Czech Republic", isoCode: "CZ" },
  "421": { min: 9, max: 9, name: "Slovakia", isoCode: "SK" },
  "423": { min: 7, max: 9, name: "Liechtenstein", isoCode: "LI" },
  "500": { min: 5, max: 5, name: "Falkland Islands", isoCode: "FK" },
  "501": { min: 7, max: 7, name: "Belize", isoCode: "BZ" },
  "502": { min: 8, max: 8, name: "Guatemala", isoCode: "GT" },
  "503": { min: 8, max: 8, name: "El Salvador", isoCode: "SV" },
  "504": { min: 8, max: 8, name: "Honduras", isoCode: "HN" },
  "505": { min: 8, max: 8, name: "Nicaragua", isoCode: "NI" },
  "506": { min: 8, max: 8, name: "Costa Rica", isoCode: "CR" },
  "507": { min: 7, max: 8, name: "Panama", isoCode: "PA" },
  "508": { min: 6, max: 6, name: "Saint Pierre", isoCode: "PM" },
  "509": { min: 8, max: 8, name: "Haiti", isoCode: "HT" },
  "590": { min: 9, max: 9, name: "Guadeloupe", isoCode: "GP" },
  "591": { min: 8, max: 8, name: "Bolivia", isoCode: "BO" },
  "592": { min: 7, max: 7, name: "Guyana", isoCode: "GY" },
  "593": { min: 9, max: 9, name: "Ecuador", isoCode: "EC" },
  "594": { min: 9, max: 9, name: "French Guiana", isoCode: "GF" },
  "595": { min: 9, max: 9, name: "Paraguay", isoCode: "PY" },
  "596": { min: 9, max: 9, name: "Martinique", isoCode: "MQ" },
  "597": { min: 6, max: 7, name: "Suriname", isoCode: "SR" },
  "598": { min: 8, max: 8, name: "Uruguay", isoCode: "UY" },
  "599": { min: 7, max: 7, name: "Curacao", isoCode: "CW" },
  "670": { min: 7, max: 8, name: "East Timor", isoCode: "TL" },
  "672": { min: 6, max: 6, name: "Norfolk Island", isoCode: "NF" },
  "673": { min: 7, max: 7, name: "Brunei", isoCode: "BN" },
  "674": { min: 7, max: 7, name: "Nauru", isoCode: "NR" },
  "675": { min: 8, max: 8, name: "Papua New Guinea", isoCode: "PG" },
  "676": { min: 5, max: 7, name: "Tonga", isoCode: "TO" },
  "677": { min: 7, max: 7, name: "Solomon Islands", isoCode: "SB" },
  "678": { min: 7, max: 7, name: "Vanuatu", isoCode: "VU" },
  "679": { min: 7, max: 7, name: "Fiji", isoCode: "FJ" },
  "680": { min: 7, max: 7, name: "Palau", isoCode: "PW" },
  "681": { min: 6, max: 6, name: "Wallis and Futuna", isoCode: "WF" },
  "682": { min: 5, max: 5, name: "Cook Islands", isoCode: "CK" },
  "683": { min: 4, max: 4, name: "Niue", isoCode: "NU" },
  "685": { min: 5, max: 7, name: "Samoa", isoCode: "WS" },
  "686": { min: 5, max: 8, name: "Kiribati", isoCode: "KI" },
  "687": { min: 6, max: 6, name: "New Caledonia", isoCode: "NC" },
  "688": { min: 5, max: 6, name: "Tuvalu", isoCode: "TV" },
  "689": { min: 6, max: 8, name: "French Polynesia", isoCode: "PF" },
  "690": { min: 4, max: 4, name: "Tokelau", isoCode: "TK" },
  "691": { min: 7, max: 7, name: "Micronesia", isoCode: "FM" },
  "692": { min: 7, max: 7, name: "Marshall Islands", isoCode: "MH" },
  "850": { min: 8, max: 9, name: "North Korea", isoCode: "KP" },
  "852": { min: 8, max: 8, name: "Hong Kong", isoCode: "HK" },
  "853": { min: 8, max: 8, name: "Macau", isoCode: "MO" },
  "855": { min: 8, max: 9, name: "Cambodia", isoCode: "KH" },
  "856": { min: 8, max: 10, name: "Laos", isoCode: "LA" },
  "880": { min: 10, max: 10, name: "Bangladesh", isoCode: "BD" },
  "886": { min: 9, max: 9, name: "Taiwan", isoCode: "TW" },
  "960": { min: 7, max: 7, name: "Maldives", isoCode: "MV" },
  "961": { min: 7, max: 8, name: "Lebanon", isoCode: "LB" },
  "962": { min: 8, max: 9, name: "Jordan", isoCode: "JO" },
  "963": { min: 9, max: 9, name: "Syria", isoCode: "SY" },
  "964": { min: 10, max: 10, name: "Iraq", isoCode: "IQ" },
  "965": { min: 8, max: 8, name: "Kuwait", isoCode: "KW" },
  "966": { min: 9, max: 9, name: "Saudi Arabia", isoCode: "SA" },
  "967": { min: 9, max: 9, name: "Yemen", isoCode: "YE" },
  "968": { min: 8, max: 8, name: "Oman", isoCode: "OM" },
  "970": { min: 9, max: 9, name: "Palestine", isoCode: "PS" },
  "971": { min: 9, max: 9, name: "UAE", isoCode: "AE" },
  "972": { min: 9, max: 9, name: "Israel", isoCode: "IL" },
  "973": { min: 8, max: 8, name: "Bahrain", isoCode: "BH" },
  "974": { min: 8, max: 8, name: "Qatar", isoCode: "QA" },
  "975": { min: 8, max: 8, name: "Bhutan", isoCode: "BT" },
  "976": { min: 8, max: 8, name: "Mongolia", isoCode: "MN" },
  "977": { min: 10, max: 10, name: "Nepal", isoCode: "NP" },
  "992": { min: 9, max: 9, name: "Tajikistan", isoCode: "TJ" },
  "993": { min: 8, max: 8, name: "Turkmenistan", isoCode: "TM" },
  "994": { min: 9, max: 9, name: "Azerbaijan", isoCode: "AZ" },
  "995": { min: 9, max: 9, name: "Georgia", isoCode: "GE" },
  "996": { min: 9, max: 9, name: "Kyrgyzstan", isoCode: "KG" },
  "998": { min: 9, max: 9, name: "Uzbekistan", isoCode: "UZ" },
  // Caribbean and other small nations with shared codes
  "1242": { min: 7, max: 7, name: "Bahamas", isoCode: "BS" },
  "1246": { min: 7, max: 7, name: "Barbados", isoCode: "BB" },
  "1264": { min: 7, max: 7, name: "Anguilla", isoCode: "AI" },
  "1268": { min: 7, max: 7, name: "Antigua", isoCode: "AG" },
  "1284": { min: 7, max: 7, name: "British Virgin Islands", isoCode: "VG" },
  "1340": { min: 7, max: 7, name: "US Virgin Islands", isoCode: "VI" },
  "1345": { min: 7, max: 7, name: "Cayman Islands", isoCode: "KY" },
  "1441": { min: 7, max: 7, name: "Bermuda", isoCode: "BM" },
  "1473": { min: 7, max: 7, name: "Grenada", isoCode: "GD" },
  "1649": { min: 7, max: 7, name: "Turks and Caicos", isoCode: "TC" },
  "1664": { min: 7, max: 7, name: "Montserrat", isoCode: "MS" },
  "1670": { min: 7, max: 7, name: "Northern Mariana Islands", isoCode: "MP" },
  "1671": { min: 7, max: 7, name: "Guam", isoCode: "GU" },
  "1684": { min: 7, max: 7, name: "American Samoa", isoCode: "AS" },
  "1721": { min: 7, max: 7, name: "Sint Maarten", isoCode: "SX" },
  "1758": { min: 7, max: 7, name: "Saint Lucia", isoCode: "LC" },
  "1767": { min: 7, max: 7, name: "Dominica", isoCode: "DM" },
  "1784": { min: 7, max: 7, name: "Saint Vincent", isoCode: "VC" },
  "1787": { min: 7, max: 7, name: "Puerto Rico", isoCode: "PR" },
  "1809": { min: 7, max: 7, name: "Dominican Republic", isoCode: "DO" },
  "1868": { min: 7, max: 7, name: "Trinidad and Tobago", isoCode: "TT" },
  "1869": { min: 7, max: 7, name: "Saint Kitts", isoCode: "KN" },
  "1876": { min: 7, max: 7, name: "Jamaica", isoCode: "JM" },
};

// Default fallback for unknown countries
const DEFAULT_PHONE_LENGTH = { min: 6, max: 15, name: "Unknown", isoCode: null };

/**
 * Get the phone number length requirements for a specific country dial code
 * @param {string} dialCode - The country dial code (e.g., "91" for India, "1" for USA)
 * @returns {Object} - Object containing min, max, and country name/code
 */
export const getPhoneNumberLength = (dialCode) => {
  const cleanDialCode = String(dialCode).replace(/[^0-9]/g, '');
  
  // Check for exact match first (handles codes like "1264" for Anguilla)
  if (COUNTRY_PHONE_DATA[cleanDialCode]) {
    return { ...COUNTRY_PHONE_DATA[cleanDialCode], dialCode: cleanDialCode };
  }
  
  // For NANP numbers (starting with 1), check for specific area codes
  if (cleanDialCode.startsWith('1') && cleanDialCode.length > 1) {
    const specificCode = cleanDialCode;
    if (COUNTRY_PHONE_DATA[specificCode]) {
      return { ...COUNTRY_PHONE_DATA[specificCode], dialCode: specificCode };
    }
    // Fall back to generic US/Canada
    return { ...COUNTRY_PHONE_DATA["1"], dialCode: "1" };
  }
  
  return { ...DEFAULT_PHONE_LENGTH, dialCode: cleanDialCode };
};

/**
 * Validate phone number based on country-specific length rules
 * This validation is lenient but still catches obviously invalid numbers
 * 
 * @param {string} phoneNumber - The phone number to validate (digits only)
 * @param {string} dialCode - The country dial code (e.g., "91" for India)
 * @returns {Object} - Object with isValid (boolean) and errorMessage (string)
 */
export const validatePhoneNumber = (phoneNumber, dialCode = "91") => {
  // Allow empty for optional fields
  if (!phoneNumber || phoneNumber.trim() === "") {
    return { isValid: true, errorMessage: "" };
  }

  // Clean the phone number - only digits
  const cleanNumber = String(phoneNumber).replace(/[^0-9]/g, '');
  
  // If still empty after cleaning
  if (!cleanNumber) {
    return { isValid: true, errorMessage: "" };
  }

  // Check if it contains only digits
  if (!/^\d+$/.test(cleanNumber)) {
    return { 
      isValid: false, 
      errorMessage: "Phone number must contain only digits" 
    };
  }

  // Get country-specific length requirements
  const lengthInfo = getPhoneNumberLength(dialCode);
  const length = cleanNumber.length;

  // Validate length with some tolerance
  // Add ±1 digit tolerance to handle edge cases
  const minWithTolerance = Math.max(lengthInfo.min - 1, 5);
  const maxWithTolerance = lengthInfo.max + 1;

  if (length < minWithTolerance) {
    if (lengthInfo.min === lengthInfo.max) {
      return {
        isValid: false,
        errorMessage: `Phone number should be ${lengthInfo.min} digits for ${lengthInfo.isoCode || lengthInfo.name}`
      };
    }
    return {
      isValid: false,
      errorMessage: `Phone number should be ${lengthInfo.min}-${lengthInfo.max} digits for ${lengthInfo.isoCode || lengthInfo.name}`
    };
  }

  if (length > maxWithTolerance) {
    if (lengthInfo.min === lengthInfo.max) {
      return {
        isValid: false,
        errorMessage: `Phone number should be ${lengthInfo.min} digits for ${lengthInfo.isoCode || lengthInfo.name}`
      };
    }
    return {
      isValid: false,
      errorMessage: `Phone number should be ${lengthInfo.min}-${lengthInfo.max} digits for ${lengthInfo.isoCode || lengthInfo.name}`
    };
  }

  // Valid!
  return { isValid: true, errorMessage: "" };
};

/**
 * Format phone number for display
 * @param {string} phoneNumber - The phone number (digits only)
 * @param {string} dialCode - The country dial code
 * @returns {string} - Formatted phone number
 */
export const formatPhoneNumber = (phoneNumber, dialCode = "91") => {
  if (!phoneNumber) return "";
  
  const cleanNumber = String(phoneNumber).replace(/[^0-9]/g, '');
  if (!cleanNumber) return "";
  
  return cleanNumber;
};

/**
 * Get validation message hint for a country
 * @param {string} dialCode - The country dial code
 * @returns {string} - Hint message about expected phone length
 */
export const getPhoneHint = (dialCode) => {
  const lengthInfo = getPhoneNumberLength(dialCode);
  
  if (lengthInfo.min === lengthInfo.max) {
    return `Expected ${lengthInfo.min} digits`;
  }
  return `Expected ${lengthInfo.min}-${lengthInfo.max} digits`;
};
